import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import { Button, IconButton } from '@material-ui/core'
import { Close as CloseIcon, DateRange as DateRangeIcon } from '@material-ui/icons'

const useStyles = makeStyles(() => ({
  date: {
    minWidth: '10rem',
    width: '10rem'
  },
  // 自定义选中日期样式
  customPicker: {
    '& .MuiPickersDay-daySelected': {
      backgroundColor: '#223B2A !important',
      color: '#ffffff !important',
      fontWeight: '600 !important',
      '&:hover': {
        backgroundColor: '#1B3023 !important',
      }
    },
    '& .MuiPickersDay-current': {
      color: '#223B2A !important',
      border: '2px solid #223B2A !important',
    },
    '& .MuiPickersDay-daySelected.MuiPickersDay-current': {
      color: '#ffffff !important',
    }
  },
  // 日历弹窗容器样式
  dialogRoot: {
    '& .MuiPickersDay-daySelected': {
      backgroundColor: '#223B2A !important',
      color: '#ffffff !important',
      fontWeight: '600 !important',
    },
    '& .MuiPickersDay-daySelected:hover': {
      backgroundColor: '#1B3023 !important',
    },
    '& .MuiPickersDay-current': {
      color: '#223B2A !important',
      border: '2px solid #223B2A !important',
    },
    '& .MuiPickersDay-daySelected.MuiPickersDay-current': {
      color: '#ffffff !important',
    }
  }
}))

type Props = {
  columnDef: any;
  onFilterChanged: (rowId: string, value?:any) => void;
  label?: string;
};

const CommonDatePickerFilter: React.FC<Props> = (props) => {
  const { columnDef, onFilterChanged, label } = props
  const classes = useStyles()
  const [editing, setEditing] = React.useState(false)
  const filterValue = columnDef.tableData.filterValue
  const hasValue = !!(filterValue?.startDate || filterValue?.endDate)

  const clearFilter = () => {
    setEditing(false)
    onFilterChanged(columnDef.tableData.id, null)
  }

  // 未选中且未展开时：只显示一个简单按钮，不显示日历选择控件
  if (!hasValue && !editing) {
    return (
      <Button
        size="small"
        variant="outlined"
        startIcon={<DateRangeIcon />}
        onClick={() => setEditing(true)}
        style={{
          minWidth: '4.5rem',
          height: '2rem',
          marginTop: '4px',
          textTransform: 'none',
          color: '#223B2A',
          borderColor: 'rgba(34, 59, 42, 0.4)'
        }}
      >
        {label || 'Date'}
      </Button>
    )
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <KeyboardDatePicker
            name="a"
            className={classes.date}
            style={{ margin: '0px', marginBottom: '4px' }}
            disableToolbar
            id={`date-picker-${columnDef.tableData.id}`}
            variant="dialog"
            inputVariant="outlined"
            format="yyyy-MM-dd"
            margin="dense"
            error={false}
            helperText={null}
            value={filterValue?.startDate || null}
            onChange={(_, inputValue) => {
              onFilterChanged(columnDef.tableData.id, {
                startDate: inputValue,
                endDate: filterValue ? filterValue.endDate : ''
              })
            }}
            label={'Start date'}
            autoOk={true}
            onFocus={() => {}}
            onBlur={() => {}}
            KeyboardButtonProps={{
              style: { padding: '4px' }
            }}
            DialogProps={{
              className: classes.dialogRoot
            }}
          />
          <KeyboardDatePicker
            name="b"
            className={`${classes.date} ${classes.customPicker}`}
            style={{ margin: '0px', marginTop: '0px' }}
            disableToolbar
            id={`date-picker-${columnDef.tableData.id}-2`}
            variant="dialog"
            inputVariant="outlined"
            format="yyyy-MM-dd"
            margin="dense"
            error={false}
            helperText={null}
            value={filterValue?.endDate || null}
            onChange={(_, inputValue) => {
              onFilterChanged(columnDef.tableData.id, {
                endDate: inputValue,
                startDate: filterValue ? filterValue.startDate : ''
              })
            }}
            label={'End date'}
            autoOk={true}
            onFocus={() => {}}
            onBlur={() => {}}
            KeyboardButtonProps={{
              style: { padding: '4px' }
            }}
            DialogProps={{
              className: classes.dialogRoot
            }}
          />
        </div>
        <IconButton
          size="small"
          onClick={clearFilter}
          title="Clear date filter"
          style={{ padding: '2px', marginLeft: '2px' }}
        >
          <CloseIcon style={{ fontSize: '16px' }} />
        </IconButton>
      </div>
    </MuiPickersUtilsProvider>
  )
}

export default CommonDatePickerFilter
